<button
  type="button"
  class="hidden lg:flex items-center justify-center cursor-pointer p-1 rounded-sm transition-all duration-200 hover:bg-gray-4 border-2 border-transparent"
  data-testid="tutorial-button"
  [attr.aria-label]="TRANSLATION_KEYS.header.HELP | translate"
  (click)="onHelpClick()"
  (keydown.enter)="onHelpClick()"
  (keydown.space)="onHelpClick()"
>
  <svg-icon
    src="assets/icons/circle-question-mark.svg"
    class="w-6 h-6 text-black"
    [svgAriaLabel]="''"
  />
</button>